<template>
  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Bildiri Düzenle</h4>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center">
            <i class="fas fa-exclamation-triangle"></i> Hata
          </h4>
          <ul class="mb-0">
            <li v-for="e in errors" :key="e">
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>

        <div class="row">
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Başlık</span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Başlık"
              v-on:change="validate"
              v-on:keyup="createUrl"
              aria-label="Başlık"
              v-bind:class="{'is-invalid' : errors.includes('Başlık')}"
              v-model="post.name"
              id="name"
              aria-describedby="basic-addon1"
            >
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="url-label">URL</span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="URL"
              aria-label="URL"
              v-on:keyup="slugifyUrl"
              v-on:change="validate"
              v-bind:class="{'is-invalid' : errors.includes('URL')}"
              v-model="post.url"
              id="url"
              aria-describedby="basic-addon1"
            >
          </div>

          <div class="col-12 input-group mb-3 d-flex flex-column align-items-end">
            <!-- <button
              class="btn btn-primary btn-sm btn-fill"
              style="margin-bottom: -34px;z-index: 2;"
              v-b-modal.croppieModal
              v-on:click="initiateCroppie('tinymce')"
            >Resim Ekle</button> -->
            <tinymce
              id="d1"
              v-model="content.content"
              v-bind:class="{'is-invalid' : errors.includes('İçerik')}"
              style="width: 100%"
              :other_options="options"
            ></tinymce>
          </div>
          <div class="col-12 col-md-11">
            <vue-tabs>
              <v-tab class="card border-top-0" title="Resim">
                <div class="row">
                  <div class="col-12 col-md-6 m-3">
                    <b-btn
                      v-b-modal.croppieModal
                      v-on:click="initiateCroppie('main')"
                      v-bind:class="{'is-invalid' : errors.includes('image')}"
                    >Resim Seç</b-btn>
                                <small class="d-block w-100 mb-3">1200 x 600 pixel</small>

                    <img
                      v-bind:src="image.file"
                      id="main-i"
                      class="img-fluid mt-4 d-block border border-secondary p-2"
                      v-bind:class="{'border-danger' : errors.includes('Resim')}"
                    >
                  </div>
                </div>
              </v-tab>
              <v-tab class="card border-top-0" title="Video">
                <div class="row">
                  <div class="col-12 input-group px-5 m-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Video Adresi</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="https://www.youtube.com/watch?v=KZzON_7EQ70"
                      aria-label="Başlık"
                      v-model="post.newvideo"
                      id="title"
                      aria-describedby="basic-addon1"
                    >
                  </div>
                </div>
              </v-tab>
              <!-- <v-tab class="card border-top-0" title="SEO">
                <div class="row settings my-4">
                  <div class="col-12 input-group px-5">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Meta Başlığı"
                      aria-label="Başlık"
                      v-model="metas.items.meta2.meta_value"
                      id="title"
                      aria-describedby="basic-addon1"
                    >
                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon1">- Statik Site Başlığı</span>
                    </div>
                  </div>
                  <div class="col-12 input-group px-5 mt-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Meta Açıklaması</span>
                    </div>
                    <textarea class="form-control" v-model="metas.items.meta3.meta_value" rows="3"></textarea>
                  </div>
                </div>
              </v-tab> -->
            </vue-tabs>
          </div>

          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
        <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
          <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()">
          <vue-croppie
            :enable-resize="false"
            :viewport="{width: 480, height: 270, type: 'suare'}"
            :boundary="{width: 640, height: 360}"
            ref="main"
            :enableOrientation="true"
            @result="result"
          ></vue-croppie>
          <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
          <b-btn class="mt-3" variant="success btn-fill float-right" @click="crop()">Kaydet</b-btn>
        </b-modal>
      </card>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/UIComponents/Cards/Card.vue';
import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue';
export default {
  data: function () {
    return {
      id: this.$route.params.id,
      // post data
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'LeaderArticles',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    }
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    addImageToEditor: function (i) {
      this.$http
        .post('/api/images/upload/' + this.post.url + '_inner-image', {
          cropped: i
        })
        .then(
          response => {
            this.content.content =
              this.content.content +
              '<img src="' +
              this.mediaURL() +
              response.body.Data.Response.name +
              '" width="100%" alt="' +
              this.post.url +
              '" />'
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          }
        )
    },
    checkForm: function () {
      this.errors = []
      if (!this.post.name) {
        this.errors.push('Başlık')
      }
      if (!this.post.url) {
        this.errors.push('URL')
      }
      if (!this.content.content) {
        this.errors.push('İçerik')
      }
      if (!this.image.cropped && !this.image.file) {
        this.errors.push('Resim')
      }
      if (!this.errors.length) {
        this.save()
      }
    },
    save: function () {
      this.toggleLoader()
      this.validateUrl()
        .then(resolve => {
          document.getElementById('url').classList.add('is-invalid')
          document.getElementById('url').classList.remove('is-valid')
          document.getElementById('url-label').classList.add('is-invalid')
          document.getElementById('url-label').classList.remove('is-valid')
          this.notifier(
            'top',
            'right',
            'danger',
            'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin'
          )
          this.toggleLoader()
        })
        .catch(er => {
          var button = event.target
          // button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
          this.saveContent()
        })
    },
    saveContent: function () {
      var button = event.target
      this.$http
        .post('/api/contents/edit/' + this.post.content.id, this.content)
        .then(
          response => {
            this.saveImage()
          },
          e => {
            button.innerHTML = 'Kaydet';
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          }
        )
    },
    saveImage: function () {
      if (this.image.cropped) {
        this.$http.post('/api/images/upload/' + this.post.url, this.image).then(
          response => {
            this.post.image = response.body.Data.Response.name
            this.savePost()
          },
          e => {
            button.innerHTML = 'Kaydet';
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          }
        )
      } else {
        this.savePost()
      }
    },
    savePost: function () {
      this.post.comments = null
      this.post.menus = null
      this.post.slider = null
      this.tempMetas = this.post.post_metas
      this.post.post_metas = null
      this.post.post_tags = null
      this.post.category = null
      this.post.sub_category = null
      this.post.user = null
      this.post.content = null
      if (this.videoupdated) {
        this.post.video = this.video
      } else {
        this.post.video = null
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140)
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(
          this.content.content,
          { allowedTags: ['br'] }
        ).substring(0, 500)
      }
      if(this.post.newvideo){
      var newvideo_id = this.post.newvideo.split('v=')[1];
      var ampersandPosition = newvideo_id.indexOf('&');
      if(ampersandPosition != -1) {
        newvideo_id = newvideo_id.substring(0, ampersandPosition);
      }
      this.post.newvideo_id = newvideo_id;
      }else{
        this.post.newvideo_id = null;
      }
       this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(
         response => {
           var pid = response.body.Data.Response.id
           this.post.id = pid
           this.slider.post_id = pid
           this.slider.order_number = pid
           this.metas.post_id = pid
           this.saveMetas()
         },
         e => {
                     this.toggleLoader();

              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
         }
       )
    },
    saveMetas: function () {
      this.$http.put('/api/post-metas/edit-bulk/', this.metas).then(
        response => {
          this.notifier('top', 'right', 'success', 'Başarılı')
          this.$router.push('/leader/articles')
          this.toggleLoader()
        },
        e => {
          this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          this.toggleLoader()
        }
      )
    },
    getInitialData: function () {
      this.toggleLoader()
      this.$http.get('/api/posts/get/' + this.id).then(
        response => {
          this.post = response.body
          this.content = this.post.content
          this.image.file = this.mediaURL() + this.post.image
          if (this.post.video) {
            this.video = this.post.video
          } else {
            this.post.video = {
              video_url: null
            }
          }
          if (this.post.slider == null) {
            this.firstSlider = true
          }
          this.metas = {
            post_id: this.post.id,
            items: {
              meta2: {
                meta_id: this.post.post_metas[this.post.meta_title].id,
                meta_key: 'title',
                meta_value: this.post.post_metas[this.post.meta_title]
                  .meta_value
              },
              meta3: {
                meta_id: this.post.post_metas[this.post.meta_description].id,
                meta_key: 'description',
                meta_value: this.post.post_metas[this.post.meta_description]
                  .meta_value
              }
            }
          }
          this.toggleLoader()
        },
        er => {
          this.toggleLoader()
          this.notifier(
            'top',
            'right',
            'danger',
            'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
          )
          return;
        }
      )
    },
    createUrl: function () {
            this.post.url = this.slugify(this.post.name)+'-la'

    },
    slugifyUrl: function () {
      this.announcement.url = this.slugify(this.announcement.url)
    },
    validate: function () {
      this.validateUrl()
        .then(resolve => {
          document.getElementById('url').classList.add('is-invalid')
          document.getElementById('url').classList.remove('is-valid')
          document.getElementById('url-label').classList.add('is-invalid')
          document.getElementById('url-label').classList.remove('is-valid')
        })
        .catch(er => {
          document.getElementById('url').classList.add('is-valid')
          document.getElementById('url').classList.remove('is-invalid')
          document.getElementById('url-label').classList.add('is-valid')
          document.getElementById('url-label').classList.remove('is-invalid')
        })
    },
    validateUrl: function () {
      var request = this
      return new Promise(function (resolve, reject) {
        request.$http
          .get(
            '/api/filter/posts/exclude/id:' +
              this.id +
              '/url/' +
              request.post.url
          )
          .then(
            response => {
              if (parseInt(response.body.meta.total) > 0) {
                resolve(true)
              } else {
                reject(false)
              }
            },
            response => {
              this.notifier(
                'top',
                'right',
                'danger',
                'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }
          )
      })
    },
    initiateCroppie (type) {
      this.croppieType = type
    },
    bind () {
      var oFReader = new FileReader()
      if (document.getElementById('myImage').files.length) {
        oFReader.readAsDataURL(document.getElementById('myImage').files[0])
        var refz = this.$refs
        oFReader.onload = function (oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          })
        };
      }
    },
          loadItems: function(){
        this.subCategories = null;
        this.createUrl();
        this.$http.get('/api/sub-categories/getsubcategories/' + this.post.category_id).then(
          response => {

          this.subCategories = response.body
          this.createUrl();
        },
        er => {
          this.toggleLoader()
          this.notifier(
            'top',
            'right',
            'danger',
            'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
          )
          return;
        }
      )
      },
    crop () {
      var dis = this
      return new Promise(resolve => {
        let options = {
          format: 'jpeg',
          size: {
            width: 1200,
            height: 600
          },
          quality: 1
        }
        dis.$refs.main.result(options, output => {
          if (this.croppieType === 'main') {
            dis.image.cropped = output
            document.getElementById('main-i').src = dis.image.cropped
          } else if (this.croppieType === 'slider') {
            dis.sliderImage.cropped = output
            dis.sliderImageLoaded = true
            document.getElementById('slider-i').src = dis.sliderImage.cropped
          } else if (this.croppieType === 'tinymce') {
            this.notifier(
              'top',
              'right',
              'warning',
              'Lütfen resim yükleninceye kadar bekleyin.'
            )
            this.addImageToEditor(output)
          }
          this.hideCroppieModal()
          dis.$refs.main.refresh()
          resolve(output)
        })
      })
    },
    hideCroppieModal () {
      this.$root.$emit('bv::hide::modal', 'croppieModal')
    },
    result (output) {
      return output
    }
  },
  mounted: function () {
    this.getInitialData()
  }
}
</script>
<style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/LeaderArticles/Edit.vue